import { TimelineMax, Expo } from 'gsap';

export default function line(el) {
  const tl = new TimelineMax({
    paused: true,
    delay: 0.25,
  });

  tl
    .addLabel('start')
    .to(el, 1.8, {
      scaleX: 1,
      ease: Expo.easeOut,
    }, 'start');

  return tl;
}
